import { Component } from "react";

// Catches any render/runtime error in the React tree and shows the actual error
// ON SCREEN instead of a blank white page. Critical for debugging the native
// iOS (WKWebView) build where the browser console is not easily accessible.
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ error, info });
    // Also surface to window so the on-screen diagnostic / Safari console catch it.
    try {
      // eslint-disable-next-line no-console
      console.error("[ErrorBoundary]", error, info?.componentStack);
    } catch (_) {}
  }

  render() {
    const { error, info } = this.state;
    if (!error) return this.props.children;

    const msg = (error && (error.message || String(error))) || "Unknown error";
    const stack = (error && error.stack) || "";
    const compStack = (info && info.componentStack) || "";

    return (
      <div
        data-testid="error-boundary"
        dir="ltr"
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 2147483647,
          background: "#1A1A1A",
          color: "#39ff14",
          font: "13px/1.55 ui-monospace, Menlo, monospace",
          padding: "20px 16px",
          overflow: "auto",
          WebkitOverflowScrolling: "touch",
          textAlign: "left",
        }}
      >
        <div style={{ color: "#fff", fontSize: 16, fontWeight: 700, marginBottom: 12 }}>
          ⚠️ تعذّر تشغيل التطبيق — App crashed
        </div>
        <div style={{ color: "#ff5b5b", fontWeight: 700, whiteSpace: "pre-wrap", marginBottom: 14 }}>
          {msg}
        </div>
        <div style={{ color: "#9aa0a6", marginBottom: 4 }}>STACK:</div>
        <pre style={{ whiteSpace: "pre-wrap", margin: 0, marginBottom: 14 }}>{stack}</pre>
        {compStack ? (
          <>
            <div style={{ color: "#9aa0a6", marginBottom: 4 }}>COMPONENT STACK:</div>
            <pre style={{ whiteSpace: "pre-wrap", margin: 0, marginBottom: 18 }}>{compStack}</pre>
          </>
        ) : null}
        <button
          data-testid="error-boundary-reload"
          onClick={() => window.location.reload()}
          style={{
            background: "#E05D3A",
            color: "#fff",
            border: "none",
            borderRadius: 10,
            padding: "12px 22px",
            fontSize: 15,
            fontWeight: 700,
          }}
        >
          إعادة المحاولة · Reload
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
